<template>
  <div class="act-text" v-html="content" :style="wrapStyle" @click="click"></div>
</template>


<script>
  /**
   * 如果没有default 并且没有指定的platform ,就不显示图片
   */
  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import {toRem} from '../../tools/tpl'
  import {getJSON, getJSONP} from "../../api/myaxios";
  import {isString, isObject} from '../../tools/typeof'
  import {onUseInfoLoad} from '../../tools/onUseInfoLoad'
  import {isArray} from '../../tools/typeof'

  function render_tpl(tpl, data, style = "") {
    if (!isString(tpl)) {
      return ''
    }
    if (!isObject(data)) {
      return tpl
    }

    for (const key in data) {
      const v = data[key] + '';
      const regex = new RegExp('\\$\\{' + key + '\\}', "g");
      if (isString(key) && isString(v)) {
        tpl = tpl.replace(regex, v)
      }
    }

    if (data._url) {
      return `<div onclick="window.location.href='${data._url}'" style="${style}">${tpl}</div>`;
    } else {
      return `<div style="${style}">${tpl}</div>`;
    }
  }


  export default {
    name: 'ActText',
    props: ['info'],
    data() {
      return {
        remote_data: null,
      }
    },
    methods: {
      click() {
        click_handler(this.info.name, () => {
          handler_action(this.info)
        }, {
          need_login: this.info.action_info.need_login,
          need_act: this.info.action_info.need_act,
          need_new_user: this.info.action_info.need_new_user,
          need_vip_level: this.info.action_info.need_vip_level,
        })
      },
      getDataFromRemote(api) {
        console.log('getDataFromRemote')
        // api = api.replace(/\$\{TICKET\}/g, window.$bus.user.ticket || '').replace(/\$\{ACT_NAME\}/g, window.rootdata.act_name || '').replace(/\$\{UUID\}/g, window.$bus.user.uuid || '')
        const param = {
          ticket: window.$bus.user.ticket
        }
        if (api.indexOf('act_name=') === -1) {
          param.act_name = window.rootdata.act_name;
        }

        let get = getJSON;
        if (api.indexOf('jsonp') !== -1) {
          get = getJSONP
        }
        console.log(api, param)
        return get(api, param).then(res => {
          if (!res) {
            return null;
          }
          if (res.ret === 0) {
            this.remote_data = res.data;
            return res.data
          }

          return null

        }).catch(e => {
          return null
        })
      }
    },
    computed: {
      content() {
        let content = this.info.t_text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');

        if (this.info.t_data_inner) {
          switch (this.info.t_data_inner) {
            case 'lottery_remain_times':
              content = "" + window.$bus.lottery.remain_chance
              break;
            case 'vip_level':
              content = "" + window.$bus.user.level;
              break;
            case 'nickname':
              content = window.$bus.user.nickname;
              break;
            default:
              break;
          }
        }

        content = `<div style=${this.style}>${content}</div>`

        //如果传入了API地址，则从API中获取值
        //t_data_source api地址，t_data_source_t 文案模板
        if (this.info.t_data_source && this.info.t_data_source_t) {
          content = '';

          //获取到了远程数据
          if (this.remote_data) {
            //如果远程数据是一个list，则输出多行文本
            if (this.remote_data.list) {
              this.remote_data.list.forEach((item, index) => {
                item['INDEX'] = (index + 1); //提供一个INDEX属性
                content += (render_tpl(this.info.t_data_source_t, item, this.style));
              })
            } else {
              //如果是个数值
              content = render_tpl(this.info.t_data_source_t, this.remote_data, this.style);
            }
          }
        }
        return content
      },

      wrapStyle() {
        const css =  {
          ...this.info.css,
        };

        //如果远程数据是一个list
        if(this.remote_data && this.remote_data.list){
          css.overflowY = 'scroll';
        }
        return css
      },

      style() {
        const css = {
          'font-size': toRem(this.info.t_size),
          'color': this.info.t_color,
          'font-weight': this.info.t_weight,
          'font-style': this.info.t_style,
          'text-decoration': this.info.t_decoration,
          'text-align': this.info.t_align,
          'line-height': this.info.t_line_height ? toRem(this.info.t_line_height) : 1.15
        };
        // const css = {
        //   fontSize: toRem(this.info.t_size),
        //   color: this.info.t_color,
        //   fontWeight: this.info.t_weight,
        //   fontStyle: this.info.t_style,
        //   textDecoration: this.info.t_decoration,
        //   textAlign: this.info.t_align,
        //   lineHeight: toRem(this.info.t_line_height)
        // };
        let res = '';
        for (const k in css) {
          res += `${k}:${css[k]};`
        }
        return res
      }
    },
    mounted() {
      const api = this.info.t_data_source;
      if (api) {
        onUseInfoLoad(() => {
          this.getDataFromRemote(api);
        }, false)
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .act-text
    position relative
    word-break break-all
    -webkit-overflow-scrolling: touch

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActText.vue